module.exports = __webpack_public_path__ + "img/document-icon.c3edb95d.png";